import React from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

export default function AntiCorruption({ data, uniqueClass , privacyLayer1 , privacyLayer2,normalSwiperLayers,environmentMobileLayer}) {
	const { t } = useTranslation()

	return (
		<div 
		className={`anti-corruption ${uniqueClass}
		 ${privacyLayer1 ? "privacyLayer1" : ""} 
		 ${privacyLayer2 ? "privacyLayer2" : ""}
		 ${normalSwiperLayers ? "normalSwiperLayers" : ""}
		 ${environmentMobileLayer ? "environmentMobileLayer" : ""}
		 `}
		 >
			<div className="header">
				<div className="first-line">
					<motion.h3
						initial={{ opacity: 0, translateY: "100%" }}
						whileInView={{ opacity: 1, translateY: 0 }}
						viewport={{ once: true }}
						transition={{ ease: "easeInOut", duration: 0.7, delay: 0.25 }}
					>
						{data.line1}
					</motion.h3>
				</div>
				{data.line2 && (
					<div className="second-line">
						<motion.h3
							initial={{ opacity: 0, translateY: "100%" }}
							whileInView={{ opacity: 1, translateY: 0 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 0.5 }}
						>
							{data.line2}
						</motion.h3>
					</div>
				)}
			</div>
			<div className="desc">
				<motion.p
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{ ease: "easeInOut", duration: 0.7, delay: 0.5 }}
				>
					{data.description}
				</motion.p>
			</div>
			{privacyLayer1 && (
				<>
				{/* <div className="back-layer3">
					<img
						src={process.env.PUBLIC_URL + "/imgs/achievements/back-layer3.png"}
						alt="back-layer5"
					/>
				</div> */}
				<div className="back-layer4">
				<img
					src={
						process.env.PUBLIC_URL +
						"/imgs/home-page/statement-back-layer4.svg"
					}
					alt="back-layer"
				/>
			</div>
			</>
			)}
			{privacyLayer2 && (
				<div className="back-layer-line">
				<img
					src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
					alt="bg"
				/>
			</div>
			)}
		{environmentMobileLayer && (
				<div className='mobile-bg'>
					<img
						src={process.env.PUBLIC_URL + '/imgs/appendices/partners-bg2.png'}
						alt='background'
					/>
				</div>
			)}
			{/* <div className="back-layer">
				<img
					src={process.env.PUBLIC_URL + "/imgs/achievements/back-layer1.png"}
					alt=""
				/>
			</div> */}
			{/* <div className="back-layer2">
				<img src={process.env.PUBLIC_URL + '/imgs/achievements/back-layer8.png'} alt="" />
			</div> */}
			{/* <div className="back-layer-wave">
				<img
					src={
						process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer4.svg"
					}
					alt="back-layer"
				/>
			</div> */}
			{normalSwiperLayers && (
					<div className="bg">
						<img
							src={
								process.env.PUBLIC_URL +
								"/imgs/home-page/statement-back-layer4.svg"
							}
							alt="back-layer"
						/>
					</div>
				)}
		</div>
	)
}
